/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_subjects_refund_not_received = /** @type {(inputs: {}) => string} */ () => {
	return `Neobdržel jsem svou refundaci.`
};

const da_contact_subjects_refund_not_received = /** @type {(inputs: {}) => string} */ () => {
	return `Jeg har ikke modtaget min refundering.`
};

const de_contact_subjects_refund_not_received = /** @type {(inputs: {}) => string} */ () => {
	return `Ich habe meine Rückerstattung nicht erhalten.`
};

const en_contact_subjects_refund_not_received = /** @type {(inputs: {}) => string} */ () => {
	return `I have not received my refund.`
};

const es_contact_subjects_refund_not_received = /** @type {(inputs: {}) => string} */ () => {
	return `No he recibido mi reembolso.`
};

const fr_contact_subjects_refund_not_received = /** @type {(inputs: {}) => string} */ () => {
	return `Je n'ai pas reçu mon remboursement.`
};

const hu_contact_subjects_refund_not_received = /** @type {(inputs: {}) => string} */ () => {
	return `Nem kaptam meg a visszatérítésem.`
};

const it_contact_subjects_refund_not_received = /** @type {(inputs: {}) => string} */ () => {
	return `Non ho ricevuto il rimborso.`
};

const nl_contact_subjects_refund_not_received = /** @type {(inputs: {}) => string} */ () => {
	return `Ik heb mijn terugbetaling niet ontvangen.`
};

const pl_contact_subjects_refund_not_received = /** @type {(inputs: {}) => string} */ () => {
	return `Nie otrzymałem zwrotu pieniędzy.`
};

const pt_contact_subjects_refund_not_received = /** @type {(inputs: {}) => string} */ () => {
	return `Ainda não recebi meu reembolso.`
};

const sv_contact_subjects_refund_not_received = /** @type {(inputs: {}) => string} */ () => {
	return `Jag har inte fått min återbetalning.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_subjects_refund_not_received = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_subjects_refund_not_received(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_subjects_refund_not_received", locale)
	if (locale === "cs") return cs_contact_subjects_refund_not_received(inputs)
	if (locale === "da") return da_contact_subjects_refund_not_received(inputs)
	if (locale === "de") return de_contact_subjects_refund_not_received(inputs)
	if (locale === "en") return en_contact_subjects_refund_not_received(inputs)
	if (locale === "es") return es_contact_subjects_refund_not_received(inputs)
	if (locale === "fr") return fr_contact_subjects_refund_not_received(inputs)
	if (locale === "hu") return hu_contact_subjects_refund_not_received(inputs)
	if (locale === "it") return it_contact_subjects_refund_not_received(inputs)
	if (locale === "nl") return nl_contact_subjects_refund_not_received(inputs)
	if (locale === "pl") return pl_contact_subjects_refund_not_received(inputs)
	if (locale === "pt") return pt_contact_subjects_refund_not_received(inputs)
	return sv_contact_subjects_refund_not_received(inputs)
};
export { contact_subjects_refund_not_received as "contact.subjects.refund_not_received" }